// extracted by mini-css-extract-plugin
var _1 = "SettingCard-module__actions--EzjbT";
var _2 = "SettingCard-module__animateUploadProgressBarWidth--ya9Gx";
var _3 = "SettingCard-module__animatedBackground--UDRVE";
var _4 = "SettingCard-module__container--fUK8t";
var _5 = "SettingCard-module__content--CNgeT";
var _6 = "SettingCard-module__details--re6tJ";
var _7 = "SettingCard-module__disabled--VHgG0";
var _8 = "SettingCard-module__hoverToShowAction--eJVD_";
var _9 = "SettingCard-module__icon--dUD52";
var _a = "SettingCard-module__titleOnly--YKyS7";
export { _1 as "actions", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "content", _6 as "details", _7 as "disabled", _8 as "hoverToShowAction", _9 as "icon", _a as "titleOnly" }
